import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { FC } from "react";
import { t } from "i18next";
import "./Signature.css";

interface SingerForm {
	vesselSigner: string;
	apprenticeSigner: string;
	buyerSigner: string;
	quotaTypeCode: string;
	showError: boolean;
}

const Signature: FC<{
	signers: SingerForm;
	setSigners: (form: SingerForm) => void;
}> = ({ signers, setSigners }) => {
	const isValid = (fieldValue: string) => {
		if (!signers.showError) return true;
		if (
			!fieldValue ||
			fieldValue === null ||
			fieldValue.trim() === "" ||
			fieldValue === undefined
		) {
			return false;
		}

		return true;
	};
	return (
		<div className="signature-form">
			<div className="signature-input-grid">
				<div className="k-form-field-wrap signature-input-field">
					<Label>{t("FishermanSignatory")}*</Label>
					<Input
						placeholder={t("SignatoryPlaceholder")}
						width={"100%"}
						value={signers?.vesselSigner}
						valid={isValid(signers.vesselSigner)}
						onChange={(e) => setSigners({ ...signers, vesselSigner: e.value })}
					/>
				</div>
				{signers.quotaTypeCode === "14" && (
					<div className="k-form-field-wrap signature-input-field">
						<Label>{t("ApprenticeSignatory")}*</Label>
						<Input
							placeholder={t("SignatoryPlaceholder")}
							width={"100%"}
							value={signers?.apprenticeSigner}
							onChange={(e) =>
								setSigners({ ...signers, apprenticeSigner: e.value })
							}
						/>
					</div>
				)}

				<div className="k-form-field-wrap signature-input-field">
					<Label>{t("BuyerSignatory")}*</Label>
					<Input
						placeholder={t("SignatoryPlaceholder")}
						width={"100%"}
						value={signers?.buyerSigner}
						valid={isValid(signers.buyerSigner)}
						onChange={(e) => setSigners({ ...signers, buyerSigner: e.value })}
					/>
				</div>
			</div>
			<div className="signature-info-block">
				<span className="signature-info-title">
					{t("SignatoryText")}
				</span>
				<div>
					<span>{t("SignatoryDate")}</span> <br />
					<span>{t("SignatoryLastname")}</span> <br />
					<span>{t("SignatoryFirstname")}</span>
				</div>
			</div>
		</div>
	);
};
export default Signature;
